import React, { useMemo, useState } from "react";
import DataTable from "../_Components/DataTable";
import SplitNumber from "../_Components/SplitNumber";
import { Link } from "react-router-dom";
function DataGrid({ data, setSelectedCheckBoxes, selectedCheckBoxes }) {
  const [lastSelected, setLastSelected] = useState(null);

  const handleToggle = (id, event) => {
    const isShiftPressed = event.shiftKey;

    if (isShiftPressed && lastSelected !== null) {
      // Find the range between lastSelected and current id
      const startIndex = data?.data?.findIndex((item) => item.id === lastSelected);
      const endIndex = data?.data?.findIndex((item) => item.id === id);
      const range = data?.data?.slice(Math.min(startIndex, endIndex), Math.max(startIndex, endIndex) + 1);
      const allIdsInRange = range.map((item) => item.id);

      // Add the first selected checkbox to the list if not already added
      setSelectedCheckBoxes((prevSelected) => {
        // Start by adding the first selected checkbox to the list
        const newSelected = [...prevSelected, lastSelected];

        // Now invert the checkboxes within the range
        allIdsInRange.forEach((checkboxId) => {
          const index = newSelected.indexOf(checkboxId);
          if (index === -1) {
            newSelected.push(checkboxId); // Add if not selected
          } else {
            newSelected.splice(index, 1); // Remove if already selected
          }
        });

        return newSelected;
      });
    } else {
      // If shift is not pressed, simply toggle the selection of this checkbox
      setSelectedCheckBoxes((prevSelected) =>
        prevSelected.includes(id) ? prevSelected.filter((selectedId) => selectedId !== id) : [...prevSelected, id],
      );
    }

    // Update the last selected checkbox
    setLastSelected(id);
  };

  const handleToggleAll = () => {
    if (data?.data?.length === selectedCheckBoxes.length) {
      setSelectedCheckBoxes([]);
    } else {
      const allCheckBoxesId = data?.data?.map((item) => item.id);
      setSelectedCheckBoxes([...allCheckBoxesId]);
    }
  };
  const columns = useMemo(() => [
    {
      accessor: "#",
      Header: () => {
        return (
          <div className="text-center cursor-pointer" onClick={() => handleToggleAll()}>
            <input
              type="checkbox"
              checked={data?.data?.length !== 0 && data?.data?.length === selectedCheckBoxes.length}
              onChange={() => { }}
              className="ml-1 ml-xl-6 pl-6 cursor-pointer"
            />
          </div>
        );
      },
      minWidth: 50,
      Cell: ({ row }) => (
        <div className="text-center cursor-pointer" onClick={(e) => handleToggle(row.original.id, e)}>
          <input
            type="checkbox"
            checked={selectedCheckBoxes.includes(row.original.id)}
            onChange={() => { }}
            className="ml-1 ml-xl-6 pl-6 cursor-pointer"
          />
        </div>
      ),
    },
    {
      accessor: "id",
      Header: "شماره بلیط",
      minWidth: 80,
    },
    {
      accessor: "basketId",
      Header: "شماره سفارش",
      minWidth: 100,
      Cell: ({ row }) => {
        return (
          <Link target="_blank" to={`/viewOrderContents/${row.original.basketId}`}>
            {row.original.basketId}
          </Link>
        );
      },
    },
    {
      accessor: "basketUserFullName",
      Header: "نام ونام خانوادگی",
      minWidth: "150px",
    },
    {
      accessor: "agentName",
      Header: "نماینده فروش",
      minWidth: "150px",
    },
    {
      accessor: "cityName",
      Header: "شهر",
      minWidth: "100px",
      Cell: ({ row }) => {
        const regionNames = row.original.amusementServiceRegions?.map((rgn) => rgn.region.name).join("، ");
        return regionNames;
      },
    },
    {
      accessor: "basketItemAmusementServiceName",
      Header: "تفریح",
      minWidth: "180px",
    },
    {
      accessor: "basketItemAmusementServiceReserveItemGroupTitle",
      Header: "آیتم",
      minWidth: "250px",
      Cell: ({ row }) => (
        <div>
          {row.original.eventTitle ? row.original.eventTitle : row.original.basketItemAmusementServiceReserveItemTitle +
            " - " +
            row.original.basketItemAmusementServiceReserveItemGroupTitle}
        </div>
      ),
    },
    {
      accessor: "basketItemSeat",
      Header: "صندلی",
      minWidth: "150px",
      Cell: ({ row }) => (!!row.original.hallSeatId &&
        <div>
          {"جایگاه: " + row.original.hallBlockName}
          <br />
          {"ردیف: " + row.original.hallRowName}
          <br />
          {"صندلی: " + row.original.hallSeatName}
        </div>
      ),
    },
    {
      accessor: "originalPrice",
      Header: "نرخ مصوب",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div style={{ textDecoration: "line-through" }}>
          <SplitNumber number={row.original.originalPrice} />
        </div>
      ),
    },

    {
      accessor: "salePrice",
      Header: "نرخ فروش",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div>
          <SplitNumber number={row.original.salePrice} />
        </div>
      ),
    },
    {
      accessor: "promoCodeDiscountPrice",
      Header: " کد تخفیف",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div>
          <SplitNumber number={row.original.promoCodeDiscountPrice} />
        </div>
      ),
    },
    {
      accessor: "price",
      Header: "قیمت نهایی",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div>
          <SplitNumber number={row.original.price} />
        </div>
      ),
    },
    {
      accessor: "supplierName",
      Header: "تامین کننده آیتم",
      minWidth: "150px",
    },
    {
      accessor: "transactionSupplierName",
      Header: "تامین کننده پرداخت شده",
      minWidth: "150px",
      Cell: ({ row }) => {
        const transactionSupplierNames = row.original.transactionSupplierNameList?.join("، ");
        return transactionSupplierNames;
      },
    },
    {
      accessor: "warantyAmount",
      Header: "پرداختی تامین کننده",
      minWidth: "100px",
      maxWidth: "100px",
      Cell: ({ row }) =>
        row.original.warantyAmount >= 0 && row.original.warantyAmount < row.original.price ? (
          <div className="">
            <SplitNumber number={row.original.warantyAmount} />
          </div>
        ) : (
          <div className="text-danger">
            <SplitNumber number={row.original.warantyAmount} />
          </div>
        ),
    },

    // {
    //     accessor: "amount",
    //     Header: "گارانتی",
    //     minWidth: '100px',
    // },
    {
      accessor: "currentStatus",
      Header: "وضعیت",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div
          className={`d-inline-block rounded-pill px-4 py-1 text-white ${row.original.currentStatus === "انجام_شده"
            ? "status-done"
            : row.original.currentStatus === "در_حال_پیگیری"
              ? "status-waiting"
              : row.original.currentStatus === "انجام_نشده"
                ? "status-failed"
                : row.original.currentStatus === "جدید" || row.original.currentStatus === "رهاسازی"
                  ? "status-new"
                  : ""
            }`}
        >
          {row.original.currentStatus}
        </div>
      ),
    },
    {
      accessor: "cancelStatus",
      Header: "وضعیت کنسلی",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div
          className={`d-inline-block rounded-pill px-4 py-1 text-white ${row.original.cancelStatus === "کنسل_شد"
            ? "status-cancel-done"
            : row.original.cancelStatus === "درخواست_کنسلی" || row.original.cancelStatus === "رهاسازی"
              ? "status-cancel-register"
              : row.original.cancelStatus === "پیگیری_کنسلی"
                ? "status-cancel-waiting"
                : row.original.cancelStatus === "رد_درخواست_کنسلی"
                  ? "status-cancel-failed"
                  : "bg-light text-dark"
            }`}
        >
          {row.original.cancelStatus}
        </div>
      ),
    },
    {
      accessor: "ticketStatus",
      Header: " وضعیت بلیط",
      minWidth: "100px",
    },
    {
      accessor: "basketItemCheckInDate",
      Header: "تاریخ استفاده",
      minWidth: "100px",
    },
    {
      accessor: "createdPersianTime",
      Header: "تاریخ ایجاد",
      minWidth: "90px",
      maxWidth: "90px",
    },
    // {
    //     Header: 'عملیات',
    //     accessor: '',
    //     minWidth: 150,
    //     align: "center",
    //     Cell: ({ row }) => (
    //         <div className="text-center">

    //             {/* ویرایش */}
    //             <Link className="btn btn-light-primary btn-sm mr-2 btn-icon" to={`/createOrEditService/${row.original.id}`}>
    //                 <i className='far fa-edit text-small'></i>
    //             </Link>
    //         </div>
    //     )
    // }
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
